module.exports = __webpack_public_path__ + "img/12.894dd3b6.png";